const MODERN_SHOWN = 4;

// Region's Drop order (newest first) with this product highlighted.
export function DropLineup({ items, productId, region }) {
  if (!items.length) return <p className="font-mono text-[10px] text-[#6B8E73]" data-testid={`drop-lineup-empty-${region}`}>// Drop is empty in {region.toUpperCase()}</p>;
  return (
    <ol className="border border-[#2A0F3D] divide-y divide-[#2A0F3D] max-h-48 overflow-y-auto" data-testid={`drop-lineup-${region}`}>
      {items.map((it, i) => {
        const me = it.id === productId;
        const shownRank = items.slice(0, i + 1).filter((x) => x.in_stock).length;
        return (
          <li key={it.id} className={`flex items-center gap-2 px-2 py-1 font-mono text-[11px] ${me ? 'bg-[#FF9F0A]/15 text-[#FF9F0A]' : 'text-[#A3C7A8]'}`} data-testid={`drop-lineup-${region}-item-${it.id}`}>
            <span className="w-5 text-right text-[#6B8E73]">{i + 1}.</span>
            <span className="flex-1 truncate">{it.name}{me && ' ← this product'}</span>
            {!it.in_stock && <span className="text-[9px] text-[#FF3B30] border border-[#FF3B30]/50 px-1">OUT · hidden</span>}
            {it.in_stock && shownRank <= MODERN_SHOWN && <span className="text-[9px] text-[#39FF14] border border-[#39FF14]/40 px-1">MODERN</span>}
          </li>
        );
      })}
    </ol>
  );
}
